import { render, staticRenderFns } from "./globalSearch.vue?vue&type=template&id=d4256878&"
import script from "./globalSearch.vue?vue&type=script&lang=js&"
export * from "./globalSearch.vue?vue&type=script&lang=js&"
import style0 from "./globalSearch.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports